export default () => ({
  includes: ['degree', 'active_covenants'],
  entities: 'dependents',
  dependents: [],
  loading: true
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/family/resources/data.js